import * as React from "react";

import type {MarkConversionT, PublishAnalyticsEventT} from "./types.ts";
import {useMarkConversion} from "./use-mark-conversion.ts";
import {usePublishAnalyticsEvent} from "./use-publish-analytics-event.ts";

export interface WithMarkConversionProps {
    markConversion: MarkConversionT;
    publishAnalyticsEvent: PublishAnalyticsEventT;
}

export type WithoutMarkConversion<T> = Omit<T, keyof WithMarkConversionProps>;

export const withMarkConversion = <
    C extends React.ComponentType<
        React.ComponentProps<C> & WithMarkConversionProps
    > & {
        displayName?: string | undefined;
    },
    OuterProps = Omit<
        JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>,
        keyof WithMarkConversionProps
    >,
>(
    WrappedComponent: C,
): React.ComponentType<OuterProps> => {
    return (props: OuterProps) => {
        const markConversion = useMarkConversion();
        const publishAnalyticsEvent = usePublishAnalyticsEvent();

        return (
            <WrappedComponent
                {...(props as any)}
                markConversion={markConversion}
                publishAnalyticsEvent={publishAnalyticsEvent}
            />
        );
    };
};
